import { render } from "./agent_kouzi.vue?vue&type=template&id=4f3f5e72&scoped=true"
import script from "./agent_kouzi.vue?vue&type=script&lang=js"
export * from "./agent_kouzi.vue?vue&type=script&lang=js"

import "./agent_kouzi.vue?vue&type=style&index=0&id=4f3f5e72&scoped=true&lang=scss"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3f5e72"]])

export default __exports__